import ReactQuill from "react-quill-new";

interface Props {
  value: string;
}

const HtmlView = ({ value }: Props) => <ReactQuill className="html-view" theme="bubble" readOnly value={value} />;

export default HtmlView;
